import { useState, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import { abrirProcesso, listarTipos, listarSecretarias, uploadDocumento } from '../services/api'
import Layout from './Layout'

export default function NovoProcesso() {
  const navigate = useNavigate()
  const [passo, setPasso] = useState(1)
  const [load, setLoad] = useState(false)
  const [erro, setErro] = useState('')
  const [tipos, setTipos] = useState([])
  const [secretarias, setSecretarias] = useState([])
  const [tipoSelecionado, setTipoSelecionado] = useState(null)
  const [arquivos, setArquivos] = useState([])
  const [uploadando, setUploadando] = useState(false)
  const [processoAberto, setProcessoAberto] = useState(null)
  const fileRef = useRef()
  const [form, setForm] = useState({
    assunto:'', prioridade:'normal', setor_destino_id:'',
    req_nome:'', req_cpf_cnpj:'', req_telefone:'', req_email:'', req_endereco:'',
    observacoes_internas:''
  })

  useEffect(() => {
    listarTipos().then(r => setTipos(r.data)).catch(() => {})
    listarSecretarias().then(r => setSecretarias(r.data)).catch(() => {})
  }, [])

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }))

  function selecionarTipo(t) {
    setTipoSelecionado(t)
    if (t.setor_destino_id) set('setor_destino_id', t.setor_destino_id)
  }

  function adicionarArquivo(e) {
    const novos = Array.from(e.target.files).map(f => ({ file: f, nome: f.name, tamanho: f.size, status: 'pendente' }))
    setArquivos(a => [...a, ...novos])
    fileRef.current.value = ''
  }

  function removerArquivo(i) {
    setArquivos(a => a.filter((_, idx) => idx !== i))
  }

  function formatBytes(b) {
    if (b < 1024) return b + ' B'
    if (b < 1024*1024) return (b/1024).toFixed(0) + ' KB'
    return (b/1024/1024).toFixed(1) + ' MB'
  }

  async function submeter() {
    if (!form.req_nome) { setErro('Nome do requerente é obrigatório'); return }
    setErro(''); setLoad(true)
    try {
      const dados = { ...form, tipo_id: tipoSelecionado?.id }
      const res = await abrirProcesso(dados)
      const processo = res.data
      setProcessoAberto(processo)

      if (arquivos.length > 0) {
        setUploadando(true)
        for (let i = 0; i < arquivos.length; i++) {
          setArquivos(a => a.map((arq, idx) => idx === i ? { ...arq, status: 'enviando' } : arq))
          try {
            await uploadDocumento(processo.id, arquivos[i].file)
            setArquivos(a => a.map((arq, idx) => idx === i ? { ...arq, status: 'ok' } : arq))
          } catch {
            setArquivos(a => a.map((arq, idx) => idx === i ? { ...arq, status: 'erro' } : arq))
          }
        }
        setUploadando(false)
      }

      navigate('/processos')
    } catch(e) {
      setErro(e.response?.data?.erro || 'Erro ao abrir processo')
    } finally { setLoad(false) }
  }

  const campo = (k, label, placeholder, tipo='text', obrig=false) => (
    <div style={{ marginBottom: 14 }}>
      <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>
        {label} {obrig && <span style={{ color:'#dc2626' }}>*</span>}
      </label>
      <input type={tipo} value={form[k]} onChange={e=>set(k,e.target.value)} placeholder={placeholder}
        style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, boxSizing:'border-box' }} />
    </div>
  )

  const passos = ['Tipo e assunto','Dados do requerente','Documentos','Revisão']

  return (
    <Layout>
      <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:24 }}>
        <span onClick={() => navigate('/processos')} style={{ fontSize:13, color:'#6b7280', cursor:'pointer' }}>← Voltar</span>
        <h1 style={{ fontSize:18, fontWeight:500, margin:0 }}>Abrir novo processo</h1>
      </div>

      <div style={{ display:'flex', gap:6, marginBottom:24, alignItems:'center', flexWrap:'wrap' }}>
        {passos.map((s,i) => (
          <div key={i} style={{ display:'flex', alignItems:'center', gap:6, fontSize:13 }}>
            <div style={{
              width:22, height:22, borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:11, fontWeight:500,
              background: passo>i+1?'#EAF3DE':passo===i+1?'#185FA5':'#f3f4f6',
              color: passo>i+1?'#3B6D11':passo===i+1?'white':'#9ca3af'
            }}>{passo>i+1?'✓':i+1}</div>
            <span style={{ color:passo===i+1?'#111':'#9ca3af', fontWeight:passo===i+1?500:400 }}>{s}</span>
            {i<3 && <span style={{ color:'#e5e7eb', marginLeft:4 }}>—</span>}
          </div>
        ))}
      </div>

      <div style={{ background:'white', borderRadius:12, border:'1px solid #e5e7eb', padding:24, maxWidth:640 }}>

        {passo === 1 && <>
          <div style={{ fontSize:13, fontWeight:500, marginBottom:12, color:'#374151' }}>Selecione o tipo de processo</div>
          {tipos.length === 0
            ? <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:8, padding:12, fontSize:13, color:'#854d0e', marginBottom:16 }}>
                Nenhum tipo cadastrado. <span onClick={() => navigate('/tipos')} style={{ textDecoration:'underline', cursor:'pointer' }}>Cadastre tipos de processo →</span>
              </div>
            : <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:16 }}>
                {tipos.map(t => (
                  <div key={t.id} onClick={() => selecionarTipo(t)} style={{
                    border:`1.5px solid ${tipoSelecionado?.id===t.id?'#185FA5':'#e5e7eb'}`,
                    borderRadius:8, padding:'10px 12px', cursor:'pointer',
                    background:tipoSelecionado?.id===t.id?'#E6F1FB':'white'
                  }}>
                    <div style={{ fontSize:13, fontWeight:500, color:tipoSelecionado?.id===t.id?'#185FA5':'#111' }}>{t.nome}</div>
                    {t.prazo_dias && <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>Prazo: {t.prazo_dias} dias</div>}
                  </div>
                ))}
              </div>
          }

          {tipoSelecionado?.documentos_lista?.length > 0 && (
            <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:8, padding:12, marginBottom:16 }}>
              <div style={{ fontSize:12, fontWeight:600, color:'#854d0e', marginBottom:6 }}>📋 Documentos necessários:</div>
              {tipoSelecionado.documentos_lista.map((d,i) => (
                <div key={i} style={{ fontSize:12, color:'#713f12', padding:'2px 0' }}>• {d}</div>
              ))}
            </div>
          )}

          {campo('assunto','Assunto / descrição','Descreva o assunto do processo','text',true)}

          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Prioridade</label>
              <select value={form.prioridade} onChange={e=>set('prioridade',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
                <option value="normal">Normal</option>
                <option value="urgente">Urgente</option>
              </select>
            </div>
            <div>
              <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Setor de destino</label>
              <select value={form.setor_destino_id} onChange={e=>set('setor_destino_id',e.target.value)}
                style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13 }}>
                <option value="">Selecione</option>
                {secretarias.map(s => <option key={s.id} value={s.id}>{s.nome}</option>)}
              </select>
            </div>
          </div>
        </>}

        {passo === 2 && <>
          {campo('req_nome','Nome completo / razão social','Nome do requerente','text',true)}
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
            <div>{campo('req_cpf_cnpj','CPF / CNPJ','000.000.000-00')}</div>
            <div>{campo('req_telefone','Telefone','(00) 00000-0000')}</div>
          </div>
          {campo('req_email','E-mail','email@exemplo.com','email')}
          {campo('req_endereco','Endereço','Rua, número, bairro')}
          <div>
            <label style={{ display:'block', fontSize:12, fontWeight:500, marginBottom:5, color:'#374151' }}>Observações internas</label>
            <textarea value={form.observacoes_internas} onChange={e=>set('observacoes_internas',e.target.value)}
              placeholder="Anotações internas (não visíveis ao cidadão)"
              style={{ width:'100%', padding:'9px 11px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, minHeight:80, resize:'vertical', boxSizing:'border-box' }} />
          </div>
        </>}

        {passo === 3 && <>
          <div style={{ fontSize:13, fontWeight:500, marginBottom:4 }}>Anexar documentos</div>
          <div style={{ fontSize:12, color:'#9ca3af', marginBottom:12 }}>Opcional agora — você pode anexar depois também</div>

          {tipoSelecionado?.documentos_lista?.length > 0 && (
            <div style={{ background:'#fef9c3', border:'1px solid #fef08a', borderRadius:8, padding:12, marginBottom:14 }}>
              <div style={{ fontSize:12, fontWeight:600, color:'#854d0e', marginBottom:4 }}>📋 Documentos necessários para {tipoSelecionado.nome}:</div>
              {tipoSelecionado.documentos_lista.map((d,i) => <div key={i} style={{ fontSize:12, color:'#713f12' }}>• {d}</div>)}
            </div>
          )}

          <div onClick={() => fileRef.current.click()} style={{
            border:'1.5px dashed #d1d5db', borderRadius:8, padding:24,
            textAlign:'center', cursor:'pointer', background:'#f9fafb', marginBottom:12
          }}>
            <div style={{ fontSize:28, marginBottom:6 }}>📎</div>
            <div style={{ fontSize:13, color:'#374151', fontWeight:500 }}>Clique para adicionar arquivos</div>
            <div style={{ fontSize:11, color:'#9ca3af', marginTop:2 }}>PDF, JPG, PNG, DOC — máx. 10MB por arquivo</div>
          </div>
          <input ref={fileRef} type="file" multiple accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" onChange={adicionarArquivo} style={{ display:'none' }} />

          {arquivos.length > 0 && (
            <div style={{ display:'flex', flexDirection:'column', gap:6 }}>
              {arquivos.map((a,i) => (
                <div key={i} style={{ display:'flex', alignItems:'center', gap:10, background:'#f9fafb', padding:'8px 12px', borderRadius:8 }}>
                  <span style={{ fontSize:18 }}>{a.nome.endsWith('.pdf')?'📄':'🖼'}</span>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:12, fontWeight:500 }}>{a.nome}</div>
                    <div style={{ fontSize:11, color:'#9ca3af' }}>{formatBytes(a.tamanho)}</div>
                  </div>
                  {a.status === 'ok' && <span style={{ color:'#3B6D11', fontSize:12 }}>✓ Enviado</span>}
                  {a.status === 'erro' && <span style={{ color:'#dc2626', fontSize:12 }}>✕ Erro</span>}
                  {a.status === 'enviando' && <span style={{ color:'#185FA5', fontSize:12 }}>⏳</span>}
                  {a.status === 'pendente' && (
                    <button onClick={() => removerArquivo(i)} style={{ background:'none', border:'none', color:'#dc2626', cursor:'pointer', fontSize:16 }}>✕</button>
                  )}
                </div>
              ))}
            </div>
          )}
        </>}

        {passo === 4 && <>
          <div style={{ fontSize:13, fontWeight:500, marginBottom:16, color:'#374151' }}>Confirme os dados antes de abrir</div>
          <div style={{ background:'#f9fafb', borderRadius:8, padding:16, marginBottom:12 }}>
            <div style={{ fontSize:11, color:'#9ca3af', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>Processo</div>
            {[
              ['Tipo', tipoSelecionado?.nome || 'Não selecionado'],
              ['Assunto', form.assunto],
              ['Prioridade', form.prioridade],
            ].map(([l,v]) => v && (
              <div key={l} style={{ display:'flex', gap:12, padding:'5px 0', borderBottom:'1px solid #e5e7eb', fontSize:13 }}>
                <div style={{ color:'#9ca3af', minWidth:80 }}>{l}</div>
                <div>{v}</div>
              </div>
            ))}
          </div>
          <div style={{ background:'#f9fafb', borderRadius:8, padding:16, marginBottom:12 }}>
            <div style={{ fontSize:11, color:'#9ca3af', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>Requerente</div>
            {[
              ['Nome', form.req_nome],
              ['CPF/CNPJ', form.req_cpf_cnpj],
              ['Telefone', form.req_telefone],
              ['E-mail', form.req_email],
            ].filter(([,v])=>v).map(([l,v]) => (
              <div key={l} style={{ display:'flex', gap:12, padding:'5px 0', borderBottom:'1px solid #e5e7eb', fontSize:13 }}>
                <div style={{ color:'#9ca3af', minWidth:80 }}>{l}</div>
                <div>{v}</div>
              </div>
            ))}
          </div>
          {arquivos.length > 0 && (
            <div style={{ background:'#f9fafb', borderRadius:8, padding:16, marginBottom:12 }}>
              <div style={{ fontSize:11, color:'#9ca3af', marginBottom:8, textTransform:'uppercase', letterSpacing:'0.5px' }}>Documentos ({arquivos.length})</div>
              {arquivos.map((a,i) => <div key={i} style={{ fontSize:13, color:'#374151', padding:'2px 0' }}>📎 {a.nome}</div>)}
            </div>
          )}
          {erro && <div style={{ background:'#fef2f2', border:'1px solid #fecaca', borderRadius:8, padding:12, fontSize:13, color:'#dc2626' }}>{erro}</div>}
        </>}
      </div>

      <div style={{ display:'flex', justifyContent:'space-between', marginTop:16, maxWidth:640 }}>
        <button onClick={() => passo>1 ? setPasso(p=>p-1) : navigate('/processos')}
          style={{ padding:'9px 18px', border:'1px solid #d1d5db', borderRadius:8, fontSize:13, cursor:'pointer', background:'white' }}>
          {passo===1 ? 'Cancelar' : '← Voltar'}
        </button>
        {passo < 4
          ? <button onClick={() => { if(passo===1&&!form.assunto){setErro('Preencha o assunto');return} setErro(''); setPasso(p=>p+1) }}
              style={{ padding:'9px 20px', background:'#185FA5', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>
              Próximo →
            </button>
          : <button onClick={submeter} disabled={load||uploadando}
              style={{ padding:'9px 20px', background:load?'#86efac':'#3B6D11', color:'white', border:'none', borderRadius:8, fontSize:13, cursor:'pointer' }}>
              {load ? 'Abrindo...' : uploadando ? 'Enviando documentos...' : '✓ Abrir processo'}
            </button>
        }
      </div>
    </Layout>
  )
}
